//import api from '../api';
import { newAPIPost } from '../api/index.js';

export default {
  state: {
    applications: [],
    searchRequest: null,
  },
  mutations: {
    updateCcicApplications(state, applications) {
      state.applications = applications;
    },
    updateSearchCcicApplicationRequest(state, searchRequest) {
      state.searchRequest = searchRequest;
    },
  },
  actions: {
    async loadCcicApplications({ commit, state }, request) {
      const fallbackRequest = request || state.searchRequest;
      const requestToSend = JSON.parse(JSON.stringify(fallbackRequest));

      if (requestToSend.ccicDate.endDate) {
        requestToSend.ccicDate.endDate = moment(requestToSend.ccicDate.endDate)
          .endOf('d')
          .toDate();
      }
      if (requestToSend.cargoCutoffDate.endDate) {
        requestToSend.cargoCutoffDate.endDate = moment(requestToSend.cargoCutoffDate.endDate)
          .endOf('d')
          .toDate();
      }

      if (requestToSend.ccicDate.startDate && !requestToSend.ccicDate.endDate) {
        requestToSend.ccicDate.endDate = moment(requestToSend.ccicDate.startDate)
          .endOf('d')
          .toDate();
      }
      if (requestToSend.cargoCutoffDate.startDate && !requestToSend.cargoCutoffDate.endDate) {
        requestToSend.cargoCutoffDate.endDate = moment(requestToSend.cargoCutoffDate.startDate)
          .endOf('d')
          .toDate();
      }
      if (requestToSend.users.length === 0 && requestToSend.usersInTeam && requestToSend.usersInTeam.length > 0) {
        requestToSend.users = requestToSend.usersInTeam;
      }

      //const result = await api.post('/api/w/ccic/application/search', requestToSend);
      const result = await newAPIPost('/api/w/ccic/application/search', requestToSend);
      commit('updateSearchCcicApplicationRequest', fallbackRequest);
      console.log(requestToSend);
      return commit('updateCcicApplications', result);
    },
  },
  getters: {
    getCcicApplications: state => state.applications,
  },
};
